import { DOCUMENT } from '@angular/common';
import { inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { fromEvent, map, startWith } from 'rxjs';
import {
  getBreakpointCssVarName,
  ThemeBreakpoint,
} from '../design-tokens/theme-breakpoints';

/**
 * Uses a media query in order to evaluate a breakpoint.
 *
 * @returns a signal with boolean value
 */
export function breakpointQuery(
  type: 'min' | 'max',
  breakPoint: ThemeBreakpoint,
): Signal<boolean> {
  const mqText = `(${type}-width: ${getBreakpointValue(breakPoint)})`;
  const mq = window.matchMedia(mqText);

  return toSignal(
    fromEvent<MediaQueryList>(mq, 'change').pipe(
      startWith(mq),
      map((query: MediaQueryList) => query.matches),
    ),
    { requireSync: true },
  );
}

/**
 * Returns the value of the breakpoint
 *
 * @param breakpoint
 * @returns
 */
function getBreakpointValue(
  breakpoint: ThemeBreakpoint,
  doc = inject(DOCUMENT),
) {
  const cssVar = getBreakpointCssVarName(breakpoint);

  return getComputedStyle(doc.documentElement).getPropertyValue(cssVar);
}
